import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_CUSTOMER_REQUESTS_KEY } from '~/features/customers/hooks/useGetCustomerRequests'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { CustomerRequest } from '~/supabase/types'

export const useUpdateCustomerRequest = () => {
  const queryClient = useQueryClient()

  const { mutate: notifyError } = useNotifyError()

  return useMutation({
    mutationKey: ['update-customer-request'],
    mutationFn: async (payload: Partial<CustomerRequest> & { id: number }) => {
      const { error } = await supabaseApi
        .from('customer_requests')
        .update(payload)
        .eq('id', payload.id)

      if (error) {
        toast.error('Customer request could not be updated')
        notifyError({
          data: { payload },
          error,
          message: 'Customer request could not be updated',
          function: 'useUpdateCustomerRequest',
        })

        throw error
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CUSTOMER_REQUESTS_KEY] })
      toast.success('Update successful.')
    },
  })
}
